import React, { useEffect, useState } from "react";
import "../Tour/Tour-post.css";
import tour1 from "../Tour/tour1.webp"; // your image path
import tour2 from "../Tour/tour2.webp"; // your image path

const TourPost = () => {
  const images = [tour1, tour2];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000); // change every 5s
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="tour-post">
      <div
        className="slider-image"
        style={{ backgroundImage: `url(${images[current]})` }}
      >
        <div className="overlayt"></div>
        <div className="tour-text">
          <h1>Discover New Horizons</h1> {/* or any other alternative */}
          <p>
            Experience unforgettable journeys across the globe with our
            expert-guided tours.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TourPost;
